// css
import "stylesheets/packs/pages/embed.scss";

// JS
// Must Have
import "regenerator-runtime/runtime";
import "jquery";
import "lazysizes";
import Rails from "rails-ujs";
Rails.start();

// Libraries
import ComponentInitializers from "components/shared/ComponentInitializers/ComponentInitializers";

// Register Window
window.vidio = window.vidio || {};
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.loadMode = 1;
window.Topic = require("shared/topic").default;
window.AhoyPageviewEvent = require("shared/ahoy_pageview_event").default;

// General Components
window.AhoyEvent = require("shared/ahoy_event").default; 
window.Kmklabs = require("components/shared/Kmklabs/Kmklabs").default; 
window.VideoBlocker = require('components/embed/VideoBlocker/VideoBlocker').default; 
window.GtmEmbed = require("embed/components/gtm_embed").default; 
window.FontLoader = require("shared/font_loader").default; 
window.EmbedInteractionStatus = require("embed/initializers/embed_interaction_status").default; 
window.EmbedFluidPlayerModifier = require("embed/initializers/embed_fluid_player_modifier").default; 

// Run component initializers
$(document).ready(function () {
  window.FontLoader.run();
  window.EmbedInteractionStatus.init();
  new ComponentInitializers();

  window.GtmEmbed.init();
  window.EmbedFluidPlayerModifier.init();
});
